export default {
  contact_form_validation_rfidNumber:
    'Muss mit ENOS beginnen und besteht nur aus Buchstaben und Zahlen',
  contact_form_label_rfid_number: 'RFID Nummer',
  external_rfid_button_activate_card: 'Karte aktivieren',
  external_rfid_form_toast_update_error: 'Leider ist ein Fehler aufgetreten.',
  external_rfid_common_required: 'Bitte ausfüllen',
  external_rfid_add_card_button: 'RFID-Karte hinzufügen',
  external_rfid_add_external_modal_title: 'Neue Karte hinzufügen',
  external_rfid_add_external_modal_description:
    'Bitte geben Sie die sichtbare Nummer auf Ihrer RFID-Karte ein.',
  external_rfid_add_external_input_label: 'RFID-Nummer',
  external_rfid_card_status_info_message:
    "Bei Deaktivierung und Störung der externen Ladekarte, wenden Sie sich bitte direkt an Ihren Leasingpartner.",
  external_rfid_add_external_input_placeholder: 'ABC 1234 56789 DEFG',
  external_rfid_add_external_button: 'Externe Ladekarte hinzufügen',
  external_rfid_add_external_success: 'Karte wurde erfolgreich zu Ihrem Account hinzugefügt.',
  external_rfid_add_external_error:
    'Externe RFID-Karte konnte nicht hinzugefügt werden.',
  external_rfid_add_external_not_found:
    'Karte nicht gefunden. Bitte überprüfen Sie die Nummer und versuchen Sie es erneut.',
  external_rfid_add_external_validation_required:
    'Bitte geben Sie die RFID-Nummer ein',
  external_rfid_add_external_validation_invalid:
    'Ungültiges RFID-Nummernformat',
  external_rfid_add_external_checking: 'Karte wird überprüft...',
  external_rfid_add_external_card_found: 'Karte gefunden!',
  external_rfid_form_toast_update_success:
    'Vielen Dank Ihre Karte ist nun aktiviert.',
  external_rfid_missing_text: 'Sie haben derzeit keine Karten.',
  external_rfid_modal_button_done: 'Fertig',
  external_rfid_modal_description:
    'Bitte geben Sie Ihre RFID-Nummer ein, die Sie auf Ihrer Karte oder im Dokument finden. Die Nummer muss mit EnOS beginnen.',
  external_rfid_modal_description_success: 'Ihre Aktivierung war erfolgreich.',
  external_rfid_modal_success: 'Ihre Karte wurde aktiviert',
  external_rfid_modal_title: 'RFID Karte aktivieren',
  external_rfid_nav_charger: 'Charger',
  external_rfid_nav_chargercards: 'Ladekarten',
  external_rfid_nav_customer_service: 'Kundenservice',
  external_rfid_nav_documents: 'Dokumente',
  external_rfid_nav_overview: 'Übersicht',
  external_rfid_nav_payment: 'Zahlung',
  external_rfid_nav_profile: 'Mein Profil',
  external_rfid_nav_tariff: 'Tarif',
  external_rfid_status_active: 'Aktiv',
  external_rfid_status_error: 'Fehler',
  external_rfid_status_inactive: 'Inaktiv',
  external_rfid_status_initial: 'Initial',
  external_rfid_status_ordered: 'Aktivierung ausstehend',
  external_rfid_title: 'Ihre Karten',
  external_rfid_use_business: 'Business Ladekarte',
  external_rfid_use_private: 'Private Ladekarte',
  external_rfid_use_external: 'Externe Ladekarte',
  external_rfid_status_processing: 'In Bearbeitung',
  external_rfid_status_pending: 'Wird bearbeitet',
  external_rfid_add_external_disabled_tooltip:
    'Geben Sie bitte zuerst die benötigten Informationen in der Sektion <a href="/auszahlung">Hausstromrückerstattung</a> ein.',
  external_rfid_univers_card_warning:
    'Die eingegebene Kartennummer gehört einer Univers-Ladekarte. Diese Ladekarten werden automatisch dem Account hinzugefügt.',
}
